<template>
  <div>
    <slot name="header">
      <CheckoutHeaderJav v-if="isAlt" />
      <CheckoutHeader v-else />
    </slot>
    <main class="flex flex-col min-h-md">
      <slot />
    </main>
    <slot name="footer">
      <LazyFooterJav v-if="isAlt" />
      <LazyFooter v-else />
    </slot>
  </div>
</template>

<script lang="ts" setup>
import CheckoutHeader from '~/components/Checkout/CheckoutHeader.vue'
const { isAlt } = useTheme()
</script>
